import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CartProvider } from './context/CartContext';

// Pages
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import { Login, Register } from './pages/Auth';
import { Orders, Checkout, Profile, Wishlist } from './pages/customer/CustomerPages';
import AdminPanel from './pages/admin/AdminPanel';
import VendorPanel from './pages/vendor/VendorPanel';

// Route guards
function PrivateRoute({ children, roles }) {
  const { isLoggedIn, role } = useAuth();
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(role)) return <Navigate to="/" replace />;
  return children;
}

function GuestRoute({ children }) {
  const { isLoggedIn, role } = useAuth();
  if (isLoggedIn) {
    if (role === 'admin') return <Navigate to="/admin" replace />;
    if (role === 'vendor') return <Navigate to="/vendor" replace />;
    return <Navigate to="/" replace />;
  }
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Home />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/product/:slug" element={<ProductDetail />} />

      {/* Auth */}
      <Route path="/login"    element={<GuestRoute><Login /></GuestRoute>} />
      <Route path="/register" element={<GuestRoute><Register /></GuestRoute>} />

      {/* Customer */}
      <Route path="/account" element={<PrivateRoute roles={['customer']}><Profile /></PrivateRoute>} />
      <Route path="/account/profile"  element={<PrivateRoute roles={['customer']}><Profile /></PrivateRoute>} />
      <Route path="/account/orders"   element={<PrivateRoute roles={['customer']}><Orders /></PrivateRoute>} />
      <Route path="/account/wishlist" element={<PrivateRoute roles={['customer']}><Wishlist /></PrivateRoute>} />
      <Route path="/checkout" element={<PrivateRoute roles={['customer']}><Checkout /></PrivateRoute>} />

      {/* Admin Panel — all sub-routes handled inside AdminPanel */}
      <Route path="/admin/*" element={<PrivateRoute roles={['admin']}><AdminPanel /></PrivateRoute>} />

      {/* Vendor Panel */}
      <Route path="/vendor/*" element={<PrivateRoute roles={['vendor','admin']}><VendorPanel /></PrivateRoute>} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AppRoutes />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                fontFamily: 'DM Sans, sans-serif',
                fontSize: '0.9rem',
                borderRadius: '10px',
                boxShadow: '0 10px 25px rgba(0,0,0,0.12)',
              },
              success: { iconTheme: { primary: '#2d6a4f', secondary: '#fff' } },
            }}
          />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
